<template src="./html/Index.html"></template>

<script>
	import Datatable from './Datatable.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'datatable': Datatable,
		},
		data () {
			return {
				//
			}
		},
		methods: {
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/providers/views/Index.vue